export const CITATION_TYPE_LABELS: Record<string, string> = {
  'certificate-of-incorporation': 'COI',
};

export const ROUND_TYPE_LABELS: Record<string, string> = {
  seed: 'Seed',
  angel: 'Angel',
  series_a: 'Series A',
  series_b: 'Series B',
  series_c: 'Series C',
  series_d: 'Series D',
  series_e: 'Series E',
  series_f: 'Series F',
  series_g: 'Series G',
  series_h: 'Series H',
  growth: 'Growth',
  convertible_note: 'Convertible Note',
  debt: 'Debt',
  ipo: 'IPO',
  spac: 'SPAC',
  secondary: 'Secondary',
};

export function formatAmount(value: number | null | undefined, currency?: string | null): string {
  if (value == null) return '—';
  const abs = Math.abs(value);
  const sign = value < 0 ? '-' : '';
  let suffix: string;
  if (abs >= 1e9) {
    suffix = `${(abs / 1e9).toFixed(1)}B`;
  } else if (abs >= 1e6) {
    suffix = `${(abs / 1e6).toFixed(0)}M`;
  } else {
    suffix = `${(abs / 1e3).toFixed(0)}K`;
  }
  const symbol = currency === 'USD' || !currency ? '$' : `${currency} `;
  return `${sign}${symbol}${suffix}`;
}

/** Cap IQ returns values in USD thousands as strings. */
export function formatCapIQAmount(raw: string | null | undefined): string {
  if (!raw) return '—';
  const num = parseFloat(raw);
  if (isNaN(num)) return raw;
  return formatAmount(num * 1000, 'USD');
}

export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '—';
  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // YYYY-MM-DD (Sacra)
  if (dateStr.includes('-')) {
    const [year, month, day] = dateStr.split('-');
    return `${MONTHS[parseInt(month, 10) - 1]} ${day}, ${year}`;
  }

  // MM/DD/YYYY (Cap IQ)
  if (dateStr.includes('/')) {
    const [month, day, year] = dateStr.split('/');
    return `${MONTHS[parseInt(month, 10) - 1]} ${day}, ${year}`;
  }

  return dateStr;
}
